import { jsx as x } from "react/jsx-runtime";
import { useController as C } from "react-hook-form";
import { TEST_IDS as k } from "./testIds.mjs";
import { Checkbox as u } from "./index5.mjs";
const E = ({
  className: b,
  checkboxPlacement: c = "center",
  control: s,
  name: r,
  defaultValue: l,
  rules: m,
  shouldUnregister: h,
  label: n,
  labelPlacement: i,
  onChange: o,
  helperText: d,
  ...f
}) => {
  const {
    field: e,
    fieldState: { error: t }
  } = C({
    name: r,
    control: s,
    rules: m,
    defaultValue: l,
    shouldUnregister: h
  }), p = (a) => {
    e.onChange(a), o && o(a, e.value);
  };
  return /* @__PURE__ */ x(
    u,
    {
      label: n,
      labelPlacement: i,
      checkboxPlacement: c,
      name: r,
      checked: !!e.value,
      onChange: p,
      hasError: !!t,
      helperText: d || t?.message,
      "data-testid": k.checkbox,
      ...f
    }
  );
};
export {
  E as FormCheckboxField
};
//# sourceMappingURL=index6.mjs.map
